export function toServerTime(date: Date): Date {
    const utcDate = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds())
    );
    utcDate.setUTCFullYear(utcDate.getUTCFullYear() - (date.getFullYear() < 100 ? 1900 : 0));
    return utcDate;
}

export function fromServerTime(date: Date): Date {
    const utcDate = toServerTime(date);
    const diff = date.getTime() - utcDate.getTime();
    const res = new Date(date.getTime());
    res.setMilliseconds(res.getMilliseconds() + diff);
    return res;
}

export function getServerTimeOffset(): number {
    return -(new Date().getTimezoneOffset() + altosoft.serverOffset);
}
